<template>
  <div class="videoCall" v-show="videoCalling">
    <video class="myStream" autoplay="autoplay" muted="muted" ref="myStream"/>
    <video class="theirStream" autoplay="autoplay" ref="theirStream"/>
    <div class="actionWrapper">
      <v-btn color="error" fab dark @click="overApp()">
        <v-icon>fas fa-down-left-and-up-right-to-center</v-icon>
      </v-btn>
      <v-btn color="error" fab dark @click="endCall()">
        <v-icon>fas fa-phone-slash</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import ChatService from "@/services/ChatService";
import MultiPeer from "@/plugins/multi-peer";
export default {
  components: {
  },
  data() {
    return {
      myStream: null,
      peerJS: null,
      componentFriends: [],
      videoCalling: false,
      friendUserId: null,
      currentCall: null
    };
  },
  computed: {
    friends() {
      return this.$store.state.chat.friends
    },
    isCordova() {
      return window.cordova
    },
  },
  watch: {},
  async mounted() {
    if(!this.peerJS) {
      this.peerJS = new MultiPeer();
    }
    const _this = this
    this.peerJS.peer.on('call', async function (peer) {
      console.log('call coming omg')
      const acceptsCall = await confirm("Videocall incoming, do you want to accept it ?");

      if(acceptsCall){
        if(!_this.myStream) {
          try {
            _this.myStream = await _this.requestLocalVideo();
          } catch(err) {
            alert(err)
            return
          }
        }
        _this.$refs.myStream.srcObject = _this.myStream
        _this.videoCalling = true;
        peer.answer(_this.myStream);

        // Receive data
        peer.on('stream', function (theirStream) {
          _this.$refs.theirStream.srcObject = theirStream;
        });

        peer.on('close', function(){
          alert("The videocall has finished");
        });

      }else{
        console.log("Call denied !");
      }
    });
  },
  methods: {
    async call(friendUserId) {
      this.friendUserId = friendUserId
      this.videoCalling = true;
      try {
        this.myStream = await this.requestLocalVideo();
      } catch(err) {
        alert(err)
        return
      }
      this.$refs.myStream.srcObject =  this.myStream
      this.callPeer(this.myStream)
    },
    async requestLocalVideo() {
      if(this.isCordova) {
        await this.getAppCamera();
        await this.getAppMicro();
      }
      return navigator.mediaDevices.getUserMedia({ audio: true, video: true });
    },
    async callPeer(stream, retry = 0, failedKeys = []) {
      retry ++

      if(retry > 4) {
        console.log('out of retry')
        return
      }
      let remotePeerId = null
      const friend = this.friends.find(friend => friend.user.id == this.friendUserId)
      if(friend && friend.key) {
        remotePeerId = friend.key
      } else {
        const keyResult = await ChatService.getKeyChat(this.friendUserId);
        remotePeerId = keyResult.key
      }
      if(!remotePeerId) {
        return true
      }
      if(!this.peerJS) {
        this.peerJS = new MultiPeer();
      }
      let connection = this.peerJS.connections[this.friendUserId];
      if(connection && connection.open) {
      
      } else {
        try {
          connection = await this.peerJS.connectPeer(
                            remotePeerId,
                            this.friendUserId,
                            this.$store.state.auth.userId
                          )
        } catch (error) {
          delete(this.peerJS.connections[this.friendUserId]);
          if(friend) {
            failedKeys.push(remotePeerId)
            const keyResult = await ChatService.getKeyChatRetry(
                                this.friendUserId, 
                                failedKeys
                              );
            if(friend.key && keyResult.key && friend.key !== keyResult.key) {
              friend.key = keyResult.key
            }
          }
          return this.callPeer(stream, retry, failedKeys)
        }
      }
      console.log('CONNECTION OPENNING')
      this.currentCall = this.peerJS.peer.call(connection.peer, stream)
      console.log('do call')
      const _this = this
      this.currentCall.on('stream', function (theirStream) {
        console.log('stream returned from peer')
        _this.$refs.theirStream.srcObject = theirStream;
      });
    },
    async getAppCamera() {
    },
    async getAppMicro() {
    },
    endCall() {
      console.log('on end call btn click')
      if(this.currentCall) {
        console.log('do close call')
        this.currentCall.close();
        let tracks = this.$refs.myStream.srcObject.getTracks();
        tracks.forEach(function(track) {
          console.log('closing my track', track)
          track.stop();
        });
        this.$refs.myStream.srcObject = null
         tracks = this.$refs.theirStream.srcObject.getTracks();
        tracks.forEach(function(track) {
          track.stop();
        });
        this.$refs.theirStream.srcObject = null
      }
      //this.videoCalling = true;
    },
    async overApp() {
    }
  }
};
</script>
<style lang="scss">
.videoCall {
  position: fixed;
  width:100vw;
  height:100vh;
  top:0;
  left:0;
  background: #000;
  z-index: 100;
  .myStream {
    position:absolute;
    width: 150px;
    height: 250px;
    z-index: 1;
    transform: rotateY(180deg);
    -webkit-transform:rotateY(180deg);
    -moz-transform:rotateY(180deg);
  }
  .theirStream {
    width: 100%;
    height: 100%;
  }
  .actionWrapper {
    position: fixed;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 2;
  }
}
</style>